import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftLoginService {

  constructor() { }

  private async generatePkceCodes() {
    const verifier = this.generateRandomString(128);
    const challenge = await this.sha256(verifier);
    const base64Challenge = this.base64UrlEncode(challenge);
    return { verifier, challenge: base64Challenge };
  }

  private generateRandomString(length: number): string {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  private async sha256(plain: string): Promise<ArrayBuffer> {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest('SHA-256', data);
  }

  private base64UrlEncode(buffer: ArrayBuffer): string {
    // @ts-ignore
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  async login() {
    const { verifier, challenge } = await this.generatePkceCodes();
    sessionStorage.setItem('pkce_verifier', verifier);
    const params = new URLSearchParams({
      client_id: environment.azureAuth.clientId,
      response_type: 'code',
      redirect_uri: environment.azureAuth.redirectUri,
      scope: 'openid profile email User.Read',
      response_mode: 'query',
      code_challenge: challenge,
      code_challenge_method: 'S256' 
    });

    const authUrl = `${environment.azureAuth.authority}/oauth2/v2.0/authorize?${params.toString()}`;
    window.location.href = authUrl;
  }
}
